export default __webpack_public_path__ + "static/media/0xa7051c5a22d963b81d71c2ba64d46a877fbc1821.f8d02e96.webp";